import { createApiRef } from '@backstage/core-plugin-api';

/**
 * ApiRef for the GameLaunchAPI.
 *
 * @public
 */
export const GameLaunchAPIRef = createApiRef({
  id: 'plugin.launches.api',
});











































export var ModalPage; (function (ModalPage) {
  const FIRST_PAGE = 0; ModalPage[ModalPage["FIRST_PAGE"] = FIRST_PAGE] = "FIRST_PAGE";
  const SECOND_PAGE = FIRST_PAGE + 1; ModalPage[ModalPage["SECOND_PAGE"] = SECOND_PAGE] = "SECOND_PAGE";
  const THIRD_PAGE = SECOND_PAGE + 1; ModalPage[ModalPage["THIRD_PAGE"] = THIRD_PAGE] = "THIRD_PAGE";
  const FOURTH_PAGE = THIRD_PAGE + 1; ModalPage[ModalPage["FOURTH_PAGE"] = FOURTH_PAGE] = "FOURTH_PAGE";
})(ModalPage || (ModalPage = {}));

export var GameLaunchStatus; (function (GameLaunchStatus) {
  const IN_PROGRESS = 'inprogress'; GameLaunchStatus["IN_PROGRESS"] = IN_PROGRESS;
  const TODO = 'todo'; GameLaunchStatus["TODO"] = TODO;
  const DONE = 'done'; GameLaunchStatus["DONE"] = DONE;
})(GameLaunchStatus || (GameLaunchStatus = {}));

export var DataTypes; (function (DataTypes) {
  const PLATFORM = 'PLATFORM'; DataTypes["PLATFORM"] = PLATFORM;
  const REGION = 'REGION'; DataTypes["REGION"] = REGION;
  const PLAY_FEATURE = 'PLAY_FEATURE'; DataTypes["PLAY_FEATURE"] = PLAY_FEATURE;
})(DataTypes || (DataTypes = {}));




















































































export var ReadinessTaskStatus; (function (ReadinessTaskStatus) {
  const TODO = 'To Do'; ReadinessTaskStatus["TODO"] = TODO;
  const IN_PROGRESS = 'In Progress'; ReadinessTaskStatus["IN_PROGRESS"] = IN_PROGRESS;
  const DONE = 'Done'; ReadinessTaskStatus["DONE"] = DONE;
})(ReadinessTaskStatus || (ReadinessTaskStatus = {}));





























































